import { useEffect } from 'react';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import ServicesGrid from './components/ServicesGrid';
import Contact from '../home/components/Contact';
import Footer from '../home/components/Footer';
import { useSchemaOrg } from '../../utils/seo';

export default function WebDesignDevelopment() {
  // Add WebPage Schema
  useSchemaOrg({
    type: 'WebPage',
    data: {
      name: 'Web Design & Development Services - Yepes WebLab',
      description: 'Professional web design and development services. Custom websites, e-commerce solutions, and responsive designs that drive results.',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/web-design-development`,
    },
  });

  // Add Service Schema for Web Design & Development
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'Service',
          position: 1,
          name: 'Landing Page Design',
          description: 'High-converting landing pages designed to capture leads and drive conversions for your business.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 2,
          name: 'Web Design',
          description: 'Custom website designs that reflect your brand identity and provide exceptional user experiences.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 3,
          name: 'E-commerce Development',
          description: 'Complete online stores with secure payment processing, inventory management, and user-friendly shopping experiences.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 4,
          name: 'Web Applications',
          description: 'Custom web applications built with modern frameworks to solve your specific business challenges.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 5,
          name: 'Responsive Design',
          description: 'Mobile-first designs that look perfect and function flawlessly on all devices and screen sizes.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 6,
          name: 'CMS Development',
          description: 'Content management systems that give you full control over your website content with ease.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
      ],
    };

    const scriptId = 'schema-web-services';
    let scriptTag = document.getElementById(scriptId);

    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }

    scriptTag.textContent = JSON.stringify(serviceSchema);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#EBEBE0]">
      <Navigation />
      <Hero />
      <ServicesGrid />
      <Contact />
      <Footer />
    </div>
  );
}
